import { useEffect, useRef } from 'react';
import { useSearchParams } from '@umijs/max';
import { navigateFromMessage } from './navigateFromMessage';

/**
 * 发送预加载完成消息的 hook
 * 向父窗口发送 postMessage，通知预加载已完成
 * @param mode 模式：'home' | 'aluminum' | 'hard' | 'quanwu'
 */
export function useSendPreLoadComplete(mode: 'home' | 'aluminum' | 'hard' | 'quanwu') {
  useEffect(() => {
    sessionStorage.setItem('visited_blank_page', 'true');
    const messageData = {
      origin: "uiapi.materialUiplugin",
      data: {
        // 预加载完成
        action: "preLoadComplete",
        preLoadCompleteMode: mode
      }
    };
    parent?.postMessage(messageData, '*');
  }, [mode]);
}

/**
 * 处理 postMessage 导航消息的 hook
 * 监听父窗口的 postMessage 事件，收到导航消息后跳转到目标地址
 * 
 */
export function usePostMessageNavigation(preLoadCompleteMode: 'home' | 'aluminum' | 'hard' | 'quanwu') {
  const [searchParams] = useSearchParams();
  const searchParamsRef = useRef(searchParams);

  // 保持 searchParams 的引用最新
  useEffect(() => {
    searchParamsRef.current = searchParams;
  }, [searchParams]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      try {
        const { origin, data } = event?.data ?? {};
        const { action, path, params, mode } = data ?? {};
        if(mode !== preLoadCompleteMode) {
          return;
        }
        // 检查消息格式：origin 为 'uiapi.materialUi' 且 action 为 'render'
        if (origin === 'uiapi.materialUi' && action === 'render') {
          navigateFromMessage(
            { path, params },
            searchParamsRef.current
          );
        }
      } catch (error) {
        console.warn('处理 postMessage 时出错:', error);
      }
    };


    // 添加消息监听
    window.addEventListener('message', handleMessage);

    // 清理监听器
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);
}

